"use strict";
/**
 * Created by jonas on 2019-10-23.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeypadDefault = void 0;
class KeypadDefault {
}
KeypadDefault.DEFAULT_LARGE_BUTTON_SIZE = new PIXI.Rectangle(0, 0, 128, 70);
KeypadDefault.DEFAULT_SMALL_BUTTON_SIZE = new PIXI.Rectangle(0, 0, 110, 60);
KeypadDefault.DEFAULT_BET_LEVELS_ROW_MAX = 5;
KeypadDefault.SCREEN_EDGE_MARGIN_TOP_LANDSCAPE = 40;
KeypadDefault.SCREEN_EDGE_MARGIN_TOP = 40;
KeypadDefault.SCREEN_EDGE_MARGIN_LEFT = 20;
KeypadDefault.PAGE_LEFT_PADDING = 20;
KeypadDefault.PAGE_HEADER_BOTTOM_MARGIN = 20;
exports.KeypadDefault = KeypadDefault;
//# sourceMappingURL=KeypadDefault.js.map